export default function alwaysFalse(): false {
  return false
}